import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		tag: {
			margin: 3,
		},
		moreTag: {
			minWidth: 38,
		},
		minButton: {
			minWidth: 0,
			color: "#aaa",
		},
	} satisfies Record<string, CSSObject>;
};